import { RefObject, useState } from 'react';

import { ReactZoomPanPinchState } from 'react-zoom-pan-pinch';

import { useTypedDispatch } from 'hooks/useTypedDispatch';
import { setIsPlaying } from 'state/actions';

export const useScreenshot = (
  videoOrImageRef: RefObject<HTMLVideoElement | HTMLImageElement>,
  setShowScreenshotModal: (showScreenshotModal: boolean) => void,
  containerRef: RefObject<any>,
  brightness: number,
  contrast: number,
) => {
  const dispatch = useTypedDispatch();

  const [image, setImage] = useState('');
  const [zoomState, setZoomState] = useState<ReactZoomPanPinchState>(
    {} as ReactZoomPanPinchState,
  );
  const getZoomState = (state: ReactZoomPanPinchState) => {
    setZoomState(state);
  };

  const snap = () => {
    if (!containerRef.current || !zoomState.scale || !videoOrImageRef.current) return;

    dispatch(setIsPlaying(false));
    const canvas = captureScreenshot(videoOrImageRef.current, containerRef, zoomState);

    setImage(canvas.toDataURL());
    setShowScreenshotModal(true);
  };

  const captureScreenshot = (
    videoOrImageEl: HTMLVideoElement | HTMLImageElement,
    containerRef: RefObject<any>,
    zoomState: ReactZoomPanPinchState,
  ) => {
    const canvas = document.createElement('canvas');
    const width = containerRef?.current.offsetWidth;
    const height = containerRef?.current.offsetHeight;
    const w: number =
      videoOrImageEl instanceof HTMLVideoElement
        ? videoOrImageEl.videoWidth
        : videoOrImageEl.width;
    const h: number =
      videoOrImageEl instanceof HTMLVideoElement
        ? videoOrImageEl.videoHeight
        : videoOrImageEl.height;
    const initScale = Math.min(width / w, height / h);
    const isInitScale = initScale.toFixed(4) === zoomState.scale.toFixed(4);

    const ctx = canvas.getContext('2d');

    if (isInitScale) {
      canvas.width = w;
      canvas.height = h;
      if (ctx) {
        ctx.filter = `brightness(${brightness}) contrast(${contrast})`;
      }
      ctx?.drawImage(videoOrImageEl, 0, 0, w, h, 0, 0, w, h);
    } else {
      const screenWidth = width / zoomState.scale;
      const screenHeight = height / zoomState.scale;

      canvas.width = screenWidth;
      canvas.height = screenHeight;

      ctx?.drawImage(
        videoOrImageEl,
        (zoomState.positionX * -1) / zoomState.scale,
        (zoomState.positionY * -1) / zoomState.scale,
        screenWidth,
        screenHeight,
        0,
        0,
        screenWidth,
        screenHeight,
      );
    }

    return canvas;
  };

  return { image, snap, getZoomState, zoomState };
};
